// To add a tag: add an entry here and the corresponding i18n key in en/fr translation.json
export const SESSION_TAGS = [
  { value: 'aftersales', labelKey: 'SESSIONS.TAG_AFTERSALES' },
  { value: 'self-test', labelKey: 'SESSIONS.TAG_SELF_TEST' },
  { value: 'research', labelKey: 'SESSIONS.TAG_RESEARCH' },
  { value: 'not-appropriate', labelKey: 'SESSIONS.TAG_NOT_APPROPRIATE' },
];
